import React, { useState } from "react";
import {
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Colxx } from "../../../../src/components/common/CustomBootstrap";
import PeerRatingList from "../peerrating/PeerRatingList";
import InvitationsPendingScreen from "../peerrating/InvitationsPendingScreen";
import PeersRatedMeScreen from "../peerrating/PeersRatedMeScreen";

const PeerRatingTab = () => {
  const [activeTab, setActiveTab] = useState("InvPending");

  return (
    <>
      <Row>
        <Colxx xxs="12">
          <Nav tabs className="separator-tabs ml-0 mb-5 nav nav-tabs">
            <NavItem className="nav-spacing-10">
              <NavLink
                className={classnames({
                  active: activeTab === "InvPending",
                  "nav-link": true,
                })}
                onClick={() => setActiveTab("InvPending")}
                to="#"
                location={{}}
              >
                Invitations pending
              </NavLink>
            </NavItem>
            {/* <NavItem className="nav-spacing-10">
              <NavLink
                className={classnames({
                  active: activeTab === 'peersrated',
                  'nav-link': true,
                })}
                onClick={() => setActiveTab('peersrated')}
                to="#"
                location={{}}
              >
                Peers I Rated
              </NavLink>
            </NavItem> */}
            <NavItem className="nav-spacing-10">
              <NavLink
                className={classnames({
                  active: activeTab === "peersratedme",
                  "nav-link": true,
                })}
                onClick={() => setActiveTab("peersratedme")}
                to="#"
                location={{}}
              >
                Peers rated me
              </NavLink>
            </NavItem>
            <NavItem className="nav-spacing-10">
              <NavLink
                className={classnames({
                  active: activeTab === "allpeers",
                  "nav-link": true,
                })}
                onClick={() => setActiveTab("allpeers")}
                to="#"
                location={{}}
              >
                All peers
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="InvPending">
              <Row>
                <Colxx xxs="12">
                  <Card className="ask-panel-border-radius">
                    <CardBody>
                      <InvitationsPendingScreen />
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            </TabPane>
            {/* <TabPane tabId="peersrated">
              <Row>
                <Colxx xxs="12">
                  <Card className="ask-panel-border-radius">
                    <CardBody>
                      <PeerRatingList/>
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            </TabPane> */}
            <TabPane tabId="peersratedme">
              <Row>
                <Colxx xxs="12">
                  <Card className="ask-panel-border-radius">
                    <CardBody>
                      <PeersRatedMeScreen />
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            </TabPane>
            <TabPane tabId="allpeers">
              <Row>
                <Colxx xxs="12">
                  <Card className="ask-panel-border-radius">
                    <CardBody>
                      <PeerRatingList />
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            </TabPane>
          </TabContent>
        </Colxx>
      </Row>
    </>
  );
};
export default PeerRatingTab;
